import React from 'react';
import {TypographyVariant, TYPOGRAPHY_VARIANT_STYLES} from '../../tokens';

interface TypographyProps {
  variant?: TypographyVariant;
  align?: 'left' | 'center' | 'right';
  children: React.ReactNode;
  className?: string;
}

export const Typography = ({
  variant = 'body',
  align = 'left',
  children,
  className = '',
}: TypographyProps) => (
  <div
    className={[
      TYPOGRAPHY_VARIANT_STYLES[variant],
      align === 'center' && 'text-center',
      align === 'right' && 'text-right',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {children}
  </div>
);
